"use client"

import * as React from "react"
import { I18nProvider } from "@workspace/ui/components/language-switcher"
import { AppSettingsProvider } from '../context/AppSettingsContext';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    
      // <NextThemesProvider
      //   attribute="class"
      //   defaultTheme="system"
      //   // enableSystem
      //   disableTransitionOnChange
      //   // enableColorScheme
      // >
      // </NextThemesProvider>

        <AppSettingsProvider>
          <I18nProvider>
            {children}
          </I18nProvider>
        </AppSettingsProvider>
  )
}
